import http from '@/http';
import { API } from '@/http/api';
import { formatLinkSearch } from '@/utils'
import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import Table from 'CMPT/common/Table';
import Select from 'CMPT/common/Select';
import SearchFormLogistics from './searchFormLogistics'
import moment from 'moment';
import { Popconfirm } from 'antd';
const approveStatus = {
    0: "审核中",
    1: "审核通过",
    2: "审核驳回",
    3: "强制下架"
  };

// 筛选项默认值
const defaultParams = {
    pageNo: 1, // 需要查询的页数
    pageSize: 10, // 每页条数
};
class LeaseOperateMsg extends Component {
    state = {
        total: 0, // 当前数据的总数
        pageNo: 1, // 当前所展示的页码
        currentPageCount: 0, //当前页面的数量
        selectParams: {  // 接口入参，必须放这里。方便分页时保存信息
            auditStatus: this.props.state,// 审批状态
            ...defaultParams
        },
        columns: [
           {
                title: '身份',
                key: "corpIdentityTypeName",
                dataIndex: 'corpIdentityTypeName',
            }, {
                title: '联系人',
                key: "contactsName",
                dataIndex: 'contactsName',
            },
            {
                title: '所属企业',
                key: "companyName",
                dataIndex: 'companyName',
            }, {
                title: '联系方式',
                key: "contactsMobile",
                dataIndex: 'contactsMobile',
            }, {
                title: '状态',
                key: "auditStatusName",
                dataIndex: 'auditStatusName',
                // render: (text, record, index) => {
                //     return <span>{approveStatus[text]}</span>;
                // },
            }, {
                title: '审批类型',
                key: "auditType",
                dataIndex: 'auditType',
                // render: (text, record) => {
                //     return <span>{text === 1 ? "初次提交" : "重新提交"}</span>;
                // },
            }, {
                title: '提交人',
                key: "createUser",
                dataIndex: 'createUser',
                 render: (text, record) => {
                     var name = text;
                     var phone = record.createUserMobile;
                     var value = (name||'')+(name?'/':"")+(phone||'');
                     
                    return <span>{value||'--'}</span>;
                },
            }, {
                title: '提交时间',
                key: "createDate",
                dataIndex: 'createDate',
                render: (text, record) => {
                    return (
                      <span>{text ? moment(text).format("YYYY-MM-DD HH:mm") : "-"}</span>
                    );
                },
            }, {
                title: '操作',
                key: 'operate',
                width: 116,
                render: (text, record, index) => {
                    return (record.auditStatus == 10 ? (
                        <div>
                            <span className="table-operate-btn">
                                <Link to={'/app/crm/sourcing/LeaseOperateMsgDetail/' + record.code + "?pageNo=" + this.state.pageNo + "&currentPageCount=" + this.state.currentPageCount} style={{ color: '#2E4AFF' }}>强制下架 </Link>
                            </span>
                            {/* <Popconfirm title="确定强制下架吗?" onConfirm={() => this.handleDelete(record.code)}>
                                <span style={{ color: '#2E4AFF', cursor: 'pointer' }}> 强制下架</span>
                            </Popconfirm> */}
                        </div>
                    ) : (
                        <span className="table-operate-btn">
                            <Link to={'/app/crm/sourcing/LeaseOperateMsgDetail/' + record.code + "?pageNo=" + this.state.pageNo + "&currentPageCount=" + this.state.currentPageCount} style={{ color: '#2E4AFF' }}>查看</Link>
                        </span>
                    ))
                    
                }
            }
        ],
        data: [],
    }

    componentWillMount() {
        if (this.props.location) {
            // 获取参数
            const search = this.props.location.search
            const formatData = formatLinkSearch(search)

            // 解析
            let pageNo1 = null;
            if (formatData && formatData.backPageNo) {
                pageNo1 = formatData.backPageNo
            }

            // 赋值
            this.setState({
                selectParams: {
                    auditStatus: this.props.state,// 审批状态
                    pageNo: pageNo1, // 当前页数
                    pageSize: 10, // 每页条数
                }
            });
        }
    }

    //初始化
    componentDidMount() {
        this.getLists();
    }
    //查询列表
    getLists = () => {
        const httpParams = { ...this.state.selectParams };
        for (let [key, value] of Object.entries(httpParams)) {

            if (value === -1 || value === '') {
                //    console.log('[key, value]',[key, value])
                httpParams[key] = undefined;
            }
        }
        console.log(this.state.selectParams, 'selectparams, ssss')
        const config = {
            api: API.sourcingBusinessInformationList,
            data: { ...httpParams },
            showLoading: true
        };

        http(config).then(res => {
            // console.log(res, 'res1111111111111111111')
            if (res.code == 200) {
                const data = res.data;
                this.setState({
                    data: data.datas || [],
                    total: Number(data.total),
                    pageNo: data.pageNo,
                    currentPageCount: data.datas ? data.datas.length : 0,
                    selectParams: { ...this.state.selectParams, pageNo: data.pageNo }
                });
            }
        })
    }

    handleDelete = (code) => {
        const config = {
            api: API.sourcingFreightAuditForcedDown,
            data: {
                code: code
            }
        };
        http(config).then(res => {
            if (res && res.code == 200) {
                this.getLists();
            }
        })
    }

    //分页
    onChangePage = (pageNo, pageSize, sort) => {
        this.setState({
            selectParams: { ...this.state.selectParams, pageNo: pageNo, pageSize: pageSize }
        }, () => {
            this.getLists()
        })
    }

    // 搜索
    onValuesChange = (allValues) => {
        let newParams = { ...this.state.selectParams, ...allValues };
        if(newParams.supplierId== -1){// -1表示全部。所以这里 移除这个supplierId字段。后端接口 null表示全部
          delete  newParams.supplierId  
        }
        this.setState({ selectParams:newParams  })
    }

    reset = (allValues) => {
        this.setState({
            selectParams: { ...defaultParams, auditStatus: this.props.state }
        }, () => {
            this.getLists();
        })
    }

    render() {
        const selectParams = this.state.selectParams
        return (
            <div className='enterprise-auth-list'>
                <div className='searchBox'>
                    <SearchFormLogistics onValuesChange={this.onValuesChange} types={false} reset={this.reset} onSearch={() => { this.getLists() }} />
                </div>
                <Table columns={this.state.columns} rowKey={(record, index) => record.code} selfProcessData={this.state.data} total={this.state.total} change={this.onChangePage} current={selectParams.pageNo} />
            </div>

        );
    }
}

export default LeaseOperateMsg;